import { SET_ONE_TAP, RESET_ONE_TAP, CLEAR_ALL, LOCATION_CHANGE } from "../actions/constants";
import defaults from "./defaults";

const base = defaults.oneTap;

const oneTapReducer = (state = base, { type, payload }) => {
  switch (type) {
    case SET_ONE_TAP:
      return { ...state, ...payload };
    case RESET_ONE_TAP:
      return base;
    case LOCATION_CHANGE:
      return { ...state, prompted: false };
    case CLEAR_ALL:
      return base;
    default:
      return state;
  }
};

export default oneTapReducer;
